function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "menu-2-outline",
  transform: "translate(-3 -6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(3 6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(0 7)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_51",
  "data-name": "Rectangle 51",
  width: 19,
  height: 3,
  rx: 0.94,
  transform: "translate(6 7)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_52",
  "data-name": "Rectangle 52",
  width: 25,
  height: 3,
  rx: 0.94,
  transform: "translate(0 14)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_53",
  "data-name": "Rectangle 53",
  width: 25,
  height: 3,
  rx: 0.94
}))));

function SvgMenuOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOutline);
export default __webpack_public_path__ + "static/media/menu-outline.b686768f.svg";
export { ForwardRef as ReactComponent };